'use client';

import { c as _c } from "react/compiler-runtime";
import OmniDialog from '@/components/OmniDialog';
import ViverseButton from '@/components/ViverseButton';
import ViverseRadio from '@/components/ViverseRadio';
import ViverseTextarea from '@/components/ViverseTextarea';
import { Form, FormControl, FormField, FormItem, FormMessage } from '@/components/ui/form';
import { REPORT_REASON_VALUES, ReportReason } from '@/constants/comment';
import { useConfigsContext } from '@/context/ConfigsContext';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
type ReportModalProps = {
  commentId: string;
  isDialogOpen: boolean;
  onSubmit: (commentId: string, reason: ReportReason, detail: string) => void;
  onClose: () => void;
  container?: HTMLElement | null;
};
const DETAIL_MAX_LENGTH = 500;
const formSchema = z.object({
  reason: z.enum(REPORT_REASON_VALUES),
  detail: z.string().max(DETAIL_MAX_LENGTH)
});
export default function ReportModal(t0) {
  const $ = _c(57);
  const {
    commentId,
    isDialogOpen,
    onSubmit,
    onClose,
    container
  } = t0;
  const t = useTranslations();
  const {
    store
  } = useConfigsContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      reason: undefined,
      detail: ""
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const initialValues = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      resolver: zodResolver(formSchema),
      mode: "onChange",
      defaultValues: initialValues
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const form = useForm(t2);
  let t3;
  if ($[2] !== t) {
    t3 = REPORT_REASON_VALUES.map(value => ({
      value,
      label: t(`report-modal.reasons.${value}`)
    }));
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const reportReasonOptions = t3;
  let t4;
  if ($[4] !== form || $[5] !== onClose) {
    t4 = () => {
      onClose();
      form.reset(initialValues);
    };
    $[4] = form;
    $[5] = onClose;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleClose = t4;
  let t5;
  if ($[7] !== commentId || $[8] !== handleClose || $[9] !== onSubmit || $[10] !== store?.credentials?.htcToken) {
    t5 = async values => {
      const htcAuthKey = store?.credentials?.htcToken;
      if (!htcAuthKey) {
        return;
      }
      onSubmit(commentId, values.reason, values.detail);
      handleClose();
    };
    $[7] = commentId;
    $[8] = handleClose;
    $[9] = onSubmit;
    $[10] = store?.credentials?.htcToken;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const submitReport = t5;
  const isSubmitDisabled = !form.formState.isValid;
  let t6;
  if ($[12] !== t) {
    t6 = t("report-modal.title");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("report-modal.description");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== form || $[17] !== submitReport) {
    t8 = form.handleSubmit(submitReport);
    $[16] = form;
    $[17] = submitReport;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== reportReasonOptions) {
    t9 = t10 => {
      const {
        field
      } = t10;
      return <FormItem><FormControl><ViverseRadio onValueChange={field.onChange} value={field.value} options={reportReasonOptions} optionRowClassName="py-0" /></FormControl><FormMessage /></FormItem>;
    };
    $[19] = reportReasonOptions;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== form.control || $[22] !== t9) {
    t10 = <FormField control={form.control} name="reason" render={t9} />;
    $[21] = form.control;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t) {
    t11 = t12 => {
      const {
        field: field_0
      } = t12;
      return <FormItem><FormControl><ViverseTextarea {...field_0} containerClassName="border-none" className="bg-vive-primary-70 text-vive-primary-30" placeholder={t("report-modal.detail-placeholder")} showMaxLength={false} maxLength={DETAIL_MAX_LENGTH} rows={4} /></FormControl><FormMessage /></FormItem>;
    };
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== form.control || $[27] !== t11) {
    t12 = <FormField control={form.control} name="detail" render={t11} />;
    $[26] = form.control;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t) {
    t13 = t("report-modal.cancel");
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== handleClose || $[32] !== t13) {
    t14 = <ViverseButton type="button" variant="secondary" onClick={handleClose}>{t13}</ViverseButton>;
    $[31] = handleClose;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t) {
    t15 = t("report-modal.report");
    $[34] = t;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== isSubmitDisabled || $[37] !== t15) {
    t16 = <ViverseButton type="submit" disabled={isSubmitDisabled} aria-disabled={isSubmitDisabled}>{t15}</ViverseButton>;
    $[36] = isSubmitDisabled;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t14 || $[40] !== t16) {
    t17 = <div className="flex w-full justify-center gap-4">{t14}{t16}</div>;
    $[39] = t14;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t10 || $[43] !== t12 || $[44] !== t17 || $[45] !== t8) {
    t18 = <form onSubmit={t8} noValidate={true} className="w-full space-y-4">{t10}{t12}{t17}</form>;
    $[42] = t10;
    $[43] = t12;
    $[44] = t17;
    $[45] = t8;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== form || $[48] !== t18) {
    t19 = <Form {...form}>{t18}</Form>;
    $[47] = form;
    $[48] = t18;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== container || $[51] !== handleClose || $[52] !== isDialogOpen || $[53] !== t19 || $[54] !== t6 || $[55] !== t7) {
    t20 = <OmniDialog title={t6} description={t7} open={isDialogOpen} onClose={handleClose} container={container}>{t19}</OmniDialog>;
    $[50] = container;
    $[51] = handleClose;
    $[52] = isDialogOpen;
    $[53] = t19;
    $[54] = t6;
    $[55] = t7;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  return t20;
}